import forge from 'apis/forge';
import { IconType } from 'components/Icon';
import ActionButton from 'components/Widget/ActionButton';
import { useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { selectActiveDesignSystem } from 'redux/db/reducers';
import { showConfirmModal } from 'redux/mode/actions';
import { RootReducer } from 'redux/reducers';
import * as routes from 'routes';

interface Props {
	label: string;
	prompt?: string;
}

const TryInProjectAction = ({ label, prompt }: Props) => {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const [isLoading, setIsLoading] = useState(false);

	const { designSystem, dsHasDraft } = useSelector(
		(r: RootReducer) => ({
			designSystem: selectActiveDesignSystem(r.db, r.mode.activeDesignSystemId),
			dsHasDraft: r.db.dsHasDraft,
		}),
		shallowEqual
	);

	const openProject = async () => {
		if (isLoading || !designSystem) return;
		setIsLoading(true);
		try {
			const res = await forge.createSceneChatFromPrompt.withToast()({
				prompt: prompt || '',
				designSystemId: designSystem.id,
			});
			navigate(routes.scene(res.scene.id, res.scene.title));
		} finally {
			setIsLoading(false);
		}
	};

	const onClick = () => {
		if (dsHasDraft) {
			dispatch(
				showConfirmModal({
					title: 'You have unpublished changes',
					description:
						'This will use the last published version of your design system — ' +
						'recent edits may not be included. To test unpublished changes, ' +
						'try generating a gallery page instead.',
					submitLabel: 'Got it',
					onSubmit: () => openProject(),
				})
			);
		} else {
			openProject();
		}
	};

	return (
		<ActionButton
			icon={IconType.PLAY}
			label={label}
			loadingLabel="Creating project..."
			isLoading={isLoading}
			prompt={prompt}
			onClick={onClick}
		/>
	);
};

export default TryInProjectAction;
